"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _data = _interopRequireDefault(require("./data"));
/**
 * Get the response code associated with a specific error code.
 *
 * @param {string} errorCode - The error code for which the response code is needed.
 * @returns {string} The response code associated with the provided error code.
 */
function getResponseCode(errorCode) {
  return _data["default"][errorCode].code;
}
var _default = exports["default"] = getResponseCode;